import { createRouter, createWebHistory } from "vue-router";
import Signin from "@/views/Signin.vue";
import Home from "@/views/Home.vue";
import Client from "@/views/Client.vue";
import Teams from "@/views/Teams.vue";
import Team from "@/views/Team.vue";
import TeamReport from "@/views/Team-Report.vue";
import ClientReport from "@/views/Client-Report.vue";
import PeopleReport from "@/views/People-Report.vue";
import Settings from "@/views/settings.vue";
import ResetPassword from "@/views/Reset-Password.vue";
import StartResetPassword from "@/views/Start-Reset-Password.vue";
import TeamLeadReport from "@/views/Team-Lead-Report.vue";
import TimeBookedPerUser from "@/views/time-booked-per-user.vue";
import ClientsProfitabilityReport from "@/views/Clients-Profitability-Dashboard.vue";
import FourOFourRedirection from "@/views/404-Redirection.vue";
import TimeSpentOnClientsByProjects from "@/views/time-spent-on-clients-by-projects.vue";
import ReactMicroFrontend from "@/views/ReactMicroFrontend.vue";

const ProtectedWrapper = {
  template: `
    <protected-pages-layout>
      <router-view/>
    </protected-pages-layout>
  `
};

const routes = [
  // {
  //   path: "/",
  //   name: "Signin",
  //   component: Signin,
  //   meta: {
  //     title: "Sign-in",
  //   },
  // },
  {
    path: '/login',
    component: ReactMicroFrontend,
    props: { module: 'Login' }
  },
  // {
  //   path: "/reset-password",
  //   name: "ResetPassword",
  //   component: ResetPassword,
  //   meta: {
  //     title: "Reset Password",
  //   },
  // },
  {
    path: '/reset-password',
    component: ReactMicroFrontend,
    props: { module: 'ResetPassword' }
  },
  // {
  //   path: "/start-reset-password",
  //   name: "StartResetPassword",
  //   component: StartResetPassword,
  //   meta: {
  //     title: "Start Reset Password",
  //   },
  // },
  {
    path: '/request-new-password',
    component: ReactMicroFrontend,
    props: { module: 'RequestNewPassword' }
  },
  {
    path: "/",
    name: "Home",
    component: ReactMicroFrontend,
    props: { module: 'Home' }
  },
  {
    path: '/accounts',
    component: ReactMicroFrontend,
    props: { module: 'Accounts' }
  },
  // {
  //   path: '/',
  //   component: ProtectedWrapper,
  //   children: [
  //     { path: '', component: () => import('@/views/Home.vue') }
  //   ]
  // },
  // {
  //   path: "/client/:id",
  //   component: Client,
  //   meta: {
  //     title: "Client",
  //   },
  // },
  {
    path: '/client/:id',
    component: ReactMicroFrontend,
    props: { module: 'ClientPage' }
  },
  {
    path: "/teams",
    component: Teams,
    meta: {
      title: "Teams",
    },
  },
  {
    path: "/teams/:id",
    component: Team,
    meta: {
      title: "Team",
    },
  },
  {
    path: "/team-report",
    component: TeamReport,
    meta: {
      title: "Team Report",
    },
  },
  {
    path: "/client/:id/report",
    component: ClientReport,
    meta: {
      title: "Client Report",
    },
  },
  {
    path: "/people-report",
    component: PeopleReport,
    meta: {
      title: "People Report",
    },
  },
  // {
  //   path: "/clients/:id/report",
  //   component: Team,
  //   meta: {
  //     title: "Team",
  //   },
  // },
  {
    path: "/settings",
    component: Settings,
    meta: {
      title: "Settings",
    },
  },
  {
    path: "/team-lead-report",
    component: TeamLeadReport,
    meta: {
      title: "Team Lead Report",
    },
  },
  {
    path: "/time-booked-per-user",
    component: TimeBookedPerUser,
    meta: {
      title: "Time Spent On Client",
    },
  },
  {
    path: "/clients-profitability-report",
    component: ClientsProfitabilityReport,
    meta: {
      title: "Clients Profitability Report",
    },
  },
  {
    path: "/:catchAll(.*)",
    component: FourOFourRedirection,
    meta: {
      title: "404 Redirection",
    },
  },
  {
    path: "/time-spent-on-clients-by-project",
    component: TimeSpentOnClientsByProjects,
    meta: {
      title: "Time Spent On Clients By Projects",
    },
  },
  {
    path: "/report/business-analyst/service-delivery-okr",
    component: ReactMicroFrontend,
    props: {module: "BAsServiceDeliveryOKRPage"},
    meta: {
      requiresAuth: true,
      allow: (user) => { user?.role === "BA"}
    }
  }
];

export const router = createRouter({
  history: createWebHistory(),
  routes: routes,
  // scrollBehavior () {
  //   return {x: 0, y: 0}
  // }
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login", "/reset-password", "/request-new-password"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = document.cookie.split("jwt=")[1];
  if (authRequired && !loggedIn) {
    const redirectPath = to.fullPath !== '/' ? `/login?redirect=${encodeURIComponent(to.fullPath)}` : '/login';
    return next(redirectPath);
  } else {
    next();
  }
});

export default router;
